<template>
    <div>
        <Mainlayout />
        <CCol sm="12" style="background-size: cover;" class="bg-0A1129">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 5%">
                            <div class="d-md-none">
                                <br /> <br /><br />
                            </div>
                            <CContainer>
                                <CCol sm="12" style="background-size: cover; margin: auto;">
                              
                              <div class="text-center">
                               <img src="../assets/img/flyhigh/custom.png" width="50px" />
                               <h4 class="custom-24px-600 text-white mt-3">Select User Type</h4>
                               <p class="custom-16px-400 text-white mt-2">Please choose your user type to proceed.</p>
                              </div>
                              
                           </CCol>
                           <CRow>
                            <CCol sm="6">
                                <CCard class="bg-0A1129 border-16px" style="border: 1px solid rgba(255, 255, 255, 0.12);">
                                    <div class="p-3">
                                        <img src="../assets/img/flyhigh/us1.png" style="max-width:100%" />
                                        <h3 class="custom-18px-600 text-center mt-3">As a Student</h3>
                                        <p class="custom-14px-400 text-white">Gain access to interactive lessons, progress tracking, and support tools tailored to help you excel in your studies and reach your academic goals.</p>
                                        <CButton type="button" class="bg-1796FD border-16px p-3 text-white mt-4" block @click="GoToSignUp()">Select</CButton>
                                    </div>
                                   

                                </CCard>
                            </CCol>
                            <CCol sm="6">
                                <CCard class="bg-0A1129 border-16px" style="border: 1px solid rgba(255, 255, 255, 0.12);">
                                    <div class="p-3">
                                        <img src="../assets/img/flyhigh/us2.png" style="max-width:100%" />
                                        <h3 class="custom-18px-600 text-center mt-3">As a Parent</h3>
                                        <p class="custom-14px-400 text-white">Monitor your child’s learning journey, track their performance, and stay connected with teachers to ensure they’re on the right path to success.</p>
                                        <CButton type="button" class="bg-1796FD border-16px p-3 text-white mt-4" block @click="GoToSignUpParent">Select</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                           </CRow>

                            </CContainer>
                            
    
    
                        </div>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
      
    
    
    </div>
</template>

<script>



  
import Vue from "vue";



import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrlBanner from "../assets/img/flyhigh/bannerlogin.png";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrlBanner,
            
        }
    },
    methods:{
        GoToSignUp()
        {
            this.$router.push("SignUp");
        },
        GoToSignUpParent()
        {
            this.$router.push("SignUpParent");
        }
    }
}

</script>